import React from 'react';
import { Modal, Result, Button, Upload, Alert } from 'antd';
import { ModalBody, ModalContainer, Container, RequestStatus } from './styles';
import readXlsxFile from 'read-excel-file';
import { readSheetNames } from 'read-excel-file';
import { withTranslation } from 'react-i18next';
import { INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL, SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL, SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL } from './translationValues';

const NAMESPACES = ['TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL', 'GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL', 'TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL', 'SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL', 'INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL', 'SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL'];
const GENERATE_PDF_NAMESPACE = 'GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL';
const TRIGGER_EMAILS_NAMESPACE = 'TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL';
const SEND_SMS_NAMESPACE = 'SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL';
const INITIATE_PHONE_CALLS = 'INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL';
const SEND_WHATSAPP = 'SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL';

const VariableUploadResultModal = props => {
  const {
    visible,
    onCancel,
    isUploadFailed,
    setErrorMessage,
    getDetails,
    isMailTemplates,
    reqMailStatus,
    isPublishedMessages,
    messagesStatus,
    messageType,
    tableVariablesInTemp,
    partialSuccess,
    complexEmailTransactions = false,
    beforeUploadEmailTransaction,
    t
  } = props;
  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={
          isPublishedMessages
            ? t(`${SEND_SMS_NAMESPACE}:${SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.MESSAGE_STATUS_MODAL_TITLE.key}`, SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.MESSAGE_STATUS_MODAL_TITLE.value)
            : isMailTemplates && reqMailStatus && reqMailStatus.length > 1 && t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.MAIL_REQUEST_STATUS_MODAL_TITLE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.MAIL_REQUEST_STATUS_MODAL_TITLE.value)
        }
        maskClosable={false}
        centered
        visible={visible}
        width={isMailTemplates && reqMailStatus.length > 1 ? '700px' : '625px'}
        onCancel={onCancel}
        footer={false}
        className="warning-modal"
      >
        <ModalBody className="uploadResult" style={{ width: '100%' }}>
          <ModalContainer
            width={isMailTemplates && reqMailStatus?.length > 1 && '500px'}
            messageStatus={isPublishedMessages}
          >
            {isPublishedMessages ? (
              messagesStatus && messagesStatus?.data && messagesStatus?.errors?.length === 0 ? (
                <>
                  <RequestStatus>
                    <p className="title reqID">{t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.SL_NO_COLUMN_TITLE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.SL_NO_COLUMN_TITLE.value)}</p>
                    <p className="title status">{t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.STATUS_COLUMN_TITLE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.STATUS_COLUMN_TITLE.value)}</p>
                  </RequestStatus>
                  {messagesStatus?.data?.map((msgStatus, index) => {
                    return (
                      <RequestStatus>
                        <p className="reqID">{index + 1}</p>
                        <p className="status">
                          {msgStatus.status.toLowerCase().includes('succes')
                            ? messageType === 'call'
                              ? t(`${INITIATE_PHONE_CALLS}:${INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_SUCCESS_MESSAGE.key}`, INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_SUCCESS_MESSAGE.value)
                              : messageType === 'whatsapp'
                              ? t(`${SEND_WHATSAPP}:${SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_SUCCESS_MESSAGE.key}`, SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_SUCCESS_MESSAGE.value)
                              : messageType === 'sms'
                              ? t(`${SEND_SMS_NAMESPACE}:${SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_SUCCESS_MESSAGE.key}`, SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_SUCCESS_MESSAGE.value)
                              : ''
                            : !msgStatus.status.toLowerCase().includes('succes')
                            ? messageType === 'call'
                              ? t(`${INITIATE_PHONE_CALLS}:${INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_ERROR_MESSAGE.key}`, INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_ERROR_MESSAGE.value)
                              : messageType === 'whatsapp'
                              ? t(`${SEND_WHATSAPP}:${SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_ERROR_MESSAGE.key}`, SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_ERROR_MESSAGE.value)
                              : messageType === 'sms'
                              ? t(`${SEND_SMS_NAMESPACE}:${SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_ERROR_MESSAGE.key}`, SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_ERROR_MESSAGE.value)
                              : ''
                            : ''}
                        </p>
                      </RequestStatus>
                    );
                  })}
                </>
              ) : (
                <Result
                  status={'error'}
                  title={
                    messageType === 'call'
                      ? t(`${INITIATE_PHONE_CALLS}:${INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_ERROR_MESSAGE.key}`, INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL.CALL_INITIATED_ERROR_MESSAGE.value)
                      : messageType === 'whatsapp'
                      ? t(`${SEND_WHATSAPP}:${SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_ERROR_MESSAGE.key}`, SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL.WHATSAPP_SENT_ERROR_MESSAGE.value)
                      : messageType === 'sms'
                      ? t(`${SEND_SMS_NAMESPACE}:${SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_ERROR_MESSAGE.key}`, SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL.SMS_SENT_ERROR_MESSAGE.value)
                      : ''
                  }
                />
              )
            ) : (isMailTemplates ? (
                reqMailStatus && reqMailStatus.length === 1
              ) : (
                reqMailStatus
              )) ? (
              !isUploadFailed ? (
                <Result
                  status={
                    (isMailTemplates && reqMailStatus[0].status?.toLowerCase().includes('fail')) ||
                    reqMailStatus?.errors?.length > 0
                      ? 'error'
                      : 'success'
                  }
                  title={
                    isMailTemplates
                      ? reqMailStatus[0].status
                        ? reqMailStatus[0].status.toLowerCase().includes('fail')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_REQUEST_FAILED_ERROR_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_REQUEST_FAILED_ERROR_MESSAGE.value)
                          : reqMailStatus[0].status.toLowerCase().includes('delivered')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqMailStatus[0].status.toLowerCase().includes('sent')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqMailStatus[0].status.toLowerCase().includes('shared')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqMailStatus[0].status.toLowerCase().includes('queue')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                          : reqMailStatus[0].status.toLowerCase().includes('process')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                          : t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                        : reqMailStatus[0].status.toLowerCase().includes('queue')
                        ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                        : reqMailStatus[0].status
                      : t(`${GENERATE_PDF_NAMESPACE}:${GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.PDF_DOWNLOADED_SUCCESS_MESSAGE.key}`, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.PDF_DOWNLOADED_SUCCESS_MESSAGE.value)
                  }
                  extra={[
                    <>
                    <Upload
                      accept=".xls, .xlsx"
                      showUploadList={false}
                      className="varUpload"
                      beforeUpload={file => {
                        if(complexEmailTransactions) {
                          beforeUploadEmailTransaction(file);
                          return;
                        }
                        if (tableVariablesInTemp?.length > 0) {
                          let allSheetNames;
                          readSheetNames(file).then(sheetNames => {
                            allSheetNames = sheetNames;
                            if (allSheetNames && allSheetNames.length > 0) {
                              for (var n = 1; n <= tableVariablesInTemp.length + 1; n++) {
                                let eachSheetName = allSheetNames[n - 1];
                                readXlsxFile(file, { sheet: n }).then(
                                  function(rows) {
                                    let validRows = rows.map(eachRow => {
                                      if (!eachRow.every(element => element === null)) {
                                        return eachRow;
                                      }
                                    });
                                    validRows = validRows?.filter(element => {
                                      return element !== undefined;
                                    });
                                    getDetails('import', validRows, allSheetNames, eachSheetName);
                                  },
                                  function(error) {
                                    let uploadedFileType = file?.name?.split('.')[1];
                                    if (uploadedFileType === 'xls' || uploadedFileType === 'xlsx') {
                                      setErrorMessage(t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                                    } else {
                                      setErrorMessage(
                                        `${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.value)} ${uploadedFileType} ${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.value)}`,
                                      );
                                    }
                                  },
                                );
                              }
                            }
                          });
                        } else {
                          readXlsxFile(file).then(
                            function(rows) {
                              let validRows = rows.map(eachRow => {
                                if (!eachRow.every(element => element === null)) {
                                  return eachRow;
                                }
                              });
                              validRows = validRows?.filter(element => {
                                return element !== undefined;
                              });
                              getDetails('import', validRows);
                            },
                            function(error) {
                              let uploadedFileType = file?.name?.split('.')[1];
                              if (uploadedFileType === 'xls' || uploadedFileType === 'xlsx') {
                                setErrorMessage(t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                              } else {
                                setErrorMessage(
                                  `${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.value)} ${uploadedFileType} ${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.value)}`,
                                );
                              }
                            },
                          );
                        }
                        onCancel();
                      }}
                    >
                      { !partialSuccess && (
                      <Button type="primary" key="console" className="varUploadBtn">
                        {isMailTemplates ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SEND_MORE_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SEND_MORE_EMAIL_MESSAGE.value) : t(`${GENERATE_PDF_NAMESPACE}:${GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.GENERATE_MORE_PDF_MESSAGE.key}`, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.GENERATE_MORE_PDF_MESSAGE.value)}
                      </Button> )}
                      
                    </Upload>
                    { partialSuccess && <Alert
                        message={t(`${GENERATE_PDF_NAMESPACE}:${GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.LIMIT_EXCEEDED_TITLE.key}`, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.LIMIT_EXCEEDED_TITLE.value)}
                        description={t(`${GENERATE_PDF_NAMESPACE}:${GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.LIMIT_EXCEEDED_DESCRIPTION.key}`, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.LIMIT_EXCEEDED_DESCRIPTION.value)}
                        type="error"
                        className='limitExceededAlert'
                    /> }
                    </>,
                  ]}
                />
              ) : (
                <Result
                  status="error"
                  title={isMailTemplates ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.UNABLE_TO_SEND_EMAIL_ERROR_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.UNABLE_TO_SEND_EMAIL_ERROR_MESSAGE.value): t(`${GENERATE_PDF_NAMESPACE}:${GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.PDF_GENERATION_ERROR_MESSAGE.key}`, GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL.PDF_GENERATION_ERROR_MESSAGE.value)}
                  extra={[
                    <Upload
                      accept=".xls, .xlsx"
                      showUploadList={false}
                      className="varUpload"
                      beforeUpload={file => {
                        if (tableVariablesInTemp?.length > 0) {
                          let allSheetNames;
                          readSheetNames(file).then(sheetNames => {
                            allSheetNames = sheetNames;
                            if (allSheetNames && allSheetNames.length > 0) {
                              for (var n = 1; n <= tableVariablesInTemp.length + 1; n++) {
                                let eachSheetName = allSheetNames[n - 1];
                                readXlsxFile(file, { sheet: n }).then(
                                  function(rows) {
                                    let validRows = rows.map(eachRow => {
                                      if (!eachRow.every(element => element === null)) {
                                        return eachRow;
                                      }
                                    });
                                    validRows = validRows?.filter(element => {
                                      return element !== undefined;
                                    });
                                    getDetails('import', validRows, allSheetNames, eachSheetName);
                                  },
                                  function(error) {
                                    let uploadedFileType = file?.name?.split('.')[1];
                                    if (uploadedFileType === 'xls' || uploadedFileType === 'xlsx') {
                                      setErrorMessage(t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                                    } else {
                                      setErrorMessage(
                                        `${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.value)} ${uploadedFileType} ${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.value)}`,
                                      );
                                    }
                                  },
                                );
                              }
                            }
                          });
                        } else {
                          readXlsxFile(file).then(
                            function(rows) {
                              let validRows = rows.map(eachRow => {
                                if (!eachRow.every(element => element === null)) {
                                  return eachRow;
                                }
                              });
                              validRows = validRows?.filter(element => {
                                return element !== undefined;
                              });
                              getDetails('import', validRows);
                            },
                            function(error) {
                              let uploadedFileType = file?.name?.split('.')[1];
                              if (uploadedFileType === 'xls' || uploadedFileType === 'xlsx') {
                                setErrorMessage(t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                              } else {
                                setErrorMessage(
                                  `${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOADED_MESSAGE.value)} ${uploadedFileType} ${t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.UPLOAD_EXCEL_FILE_MESSAGE.value)}`,
                                );
                              }
                            },
                          );
                        }
                        onCancel();
                      }}
                    >
                      <Button type="primary" key="console" className="varUploadBtn">
                        {t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.TRY_AGAIN_BUTTON.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.TRY_AGAIN_BUTTON.value)}
                      </Button>
                    </Upload>,
                  ]}
                />
              )
            ) : (
              <>
                <RequestStatus>
                  <p className="title reqID">{t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.REQUEST_ID_COLUMN_TITLE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.REQUEST_ID_COLUMN_TITLE.value)}</p>
                  <p className="title status">{t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.STATUS_COLUMN_TITLE.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.STATUS_COLUMN_TITLE.value)}</p>
                </RequestStatus>
                {reqMailStatus.map(reqStatus => {
                  let eachReqStatus = reqStatus.status.toLowerCase().includes('fail')
                    ? t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.FAILURE_REQUEST_STATUS.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.FAILURE_REQUEST_STATUS.value)
                    : reqStatus.status.toLowerCase().includes('not delivered')
                    ? t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.FAILURE_REQUEST_STATUS.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.FAILURE_REQUEST_STATUS.value)
                    : reqStatus.status.toLowerCase().includes('shared')
                    ? t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.SUCCESS_REQUEST_STATUS.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.SUCCESS_REQUEST_STATUS.value)
                    : reqStatus.status.toLowerCase().includes('processing')
                    ? t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.PROCESSING_REQUEST_STATUS.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.PROCESSING_REQUEST_STATUS.value)
                    : reqStatus.status.toLowerCase().includes('queue')
                    ? t(TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.PROCESSING_REQUEST_STATUS.key, TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL.PROCESSING_REQUEST_STATUS.value)
                    : '';
                  return (
                    <RequestStatus eachReqStatus={eachReqStatus}>
                      <p className="reqID">{reqStatus.id}</p>
                      <p className="status">
                        {reqStatus.status.toLowerCase().includes('fail')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_REQUEST_FAILED_ERROR_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_REQUEST_FAILED_ERROR_MESSAGE.value)
                          : reqStatus.status.toLowerCase().includes('delivered')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqStatus.status.toLowerCase().includes('sent')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqStatus.status.toLowerCase().includes('shared')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.EMAIL_SENT_SUCCESS_MESSAGE.value)
                          : reqStatus.status.toLowerCase().includes('queue')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                          : reqStatus.status.toLowerCase().includes('process')
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.SENDING_EMAIL_MESSAGE.value)
                          : reqStatus.status === 'Add Email Request Fails'
                          ? t(`${TRIGGER_EMAILS_NAMESPACE}:${TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.TO_ADDRESS_INVALID_ERROR_MESSAGE.key}`, TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL.TO_ADDRESS_INVALID_ERROR_MESSAGE.value)
                          : reqStatus.status}
                      </p>
                    </RequestStatus>
                  );
                })}
              </>
            )}
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(VariableUploadResultModal);
